<!-- new theme implementation starts -->
<div class="subheader with-padding flgrow">
  <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-8">
      <div class="relative flmid">
        <div class="flgrow">
          <div class="input-group">
          <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
            [(ngModel)]="searchTerm" autocomplete="off" (keyup.enter)="onSearchFilter()"/>
            <div class="input-group-append">
              <button type="button" class="btn btn-primary" (click)="onSearchFilter()">
                <em class="fa fa-search"></em>
              </button>
            </div>
            </div>
        </div>
      </div>
    </div>
    <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd">
      <button type="button" type="reset" aria-label="Center Align" class="add-button btn btn-primary" translate
        (click)="onAdd()">lblAddDiagnoseTemplate</button>
    </div>
  </div>
</div>
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex justify-content-between" translate>
            lblDiagnoseTemplate
            <div class="font16 fontbold">
              <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
                  totalCount
                  }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
          </div>
        </div>
        <div class="table-responsive max-h254"
        infinite-scroll
        [infiniteScrollDistance]="scrollDistance"
        [infiniteScrollThrottle]="throttle"
        [scrollWindow]="false"
        (scrolled)="onScrollDown($event)">
        <table class="tablest1">
          <thead>
            <tr>
              <th style="width: 55px" scope="col">#</th>
              <th style="width: 15%" scope="col" translate>lblType</th>
              <th style="width: 20%" scope="col" sortable="name" (sort)="onSort($event)" translate>lblName</th>
              <th style="width: 40%" scope="col" sortable="templates" (sort)="onSort($event)" translate>lblDiagnoseTemplate</th>
              <th style="width: 110px" class="text-center" scope="col" sortable="isActive" (sort)="onSort($event)" translate>lblActive</th>
              <th style="width: 120px" class="text-center" scope="col"  translate>lblAction</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="diagnoseTemplateList?.length>0; else load_else">
              <tr *ngFor="let template of diagnoseTemplateList; let i=index">
                <td>{{ template.rowNumber }}</td>
                <td>
                  <ngb-highlight [result]="template.listType"></ngb-highlight>
                </td>
                <td>
                  <ngb-highlight [result]="template.name"></ngb-highlight>
                </td>
                <td>
                  <ngb-highlight [result]="template.templates"></ngb-highlight>
                </td>
                <td class="text-center">
                    <em class="fas fa-check" *ngIf="template.isActive"></em>
                    <em class="fas fa-close" *ngIf="!template.isActive"></em>
                </td>
                <td class="nowrap text-center">
                  <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert" *ngIf="userRoleRightsDetails.canEdit" (click)="onEdit(template.templateId)">
                    <em class="fas fa-pencil-alt fa-lg"></em>
                  </a>
                  <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                  <a class="btn btn-ico"  ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert" *ngIf="userRoleRightsDetails.canDelete" (click)="deleteDiagnoseTemplate(template.templateId)">
                    <em class="far fa-trash-alt fa-lg"></em>
                  </a>
                </td>
              </tr>
            </ng-container>
            <ng-template #load_else>
              <tr>
                <td colspan="6" class="no-record" translate>lblNoRecordsFound</td>
              </tr>
            </ng-template>
          </tbody>
        </table>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- new theme implementation ends -->
